const accessCode = state => state.accessCode

export default {
  accessCode
}
